import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import PeopleIcon from '@mui/icons-material/People';

const Metrics = () => {
  const theme = useTheme();
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const getIcon = (iconName) => {
    const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };
    switch (iconName) {
      case 'LanguageIcon':
        return <LanguageIcon {...iconProps} />;
      case 'OndemandVideoIcon':
        return <OndemandVideoIcon {...iconProps} />;
      case 'LiveTvIcon':
        return <LiveTvIcon {...iconProps} />;
      case 'PeopleIcon':
        return <PeopleIcon {...iconProps} />;
      default:
        return <LanguageIcon {...iconProps} />;
    }
  };

  const metricsData = [
    {
      title: 500,
      label: 'Audiencia mensual en plataforma',
      subtitle: 'Nicho de alta fidelidad.',
      suffix: '+',
      icon: getIcon('PeopleIcon'),
    },
    {
      title: 30000,
      label: 'Visitas mensuales del ecosistema TNO',
      subtitle: 'Integración web y editorial.',
      suffix: '+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 5,
      label: 'Episodios On-Demand disponibles',
      subtitle: 'Contenido educativo de larga duración.',
      suffix: '+',
      icon: getIcon('OndemandVideoIcon'),
    },
    {
      title: 1,
      label: 'Emisión en vivo semanal',
      subtitle: 'Consultar horario por TNO Network.',
      suffix: '',
      icon: getIcon('LiveTvIcon'),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color={'primary'}
          align={'center'}
        >
          Números
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          align={'center'}
          gutterBottom
          color={'primary'}
        >
          El impacto de Pedro con las Mascotas
        </Box>
        <Typography variant={'h6'} align={'center'} color="textSecondary" sx={{ mb: 4 }}>
          Tu marca llega a una audiencia emocionalmente conectada que invierte prioritariamente en el cuidado de sus animales.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
                {item.icon}
              </Box>
              <Typography variant="h3" align={'center'} gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor onChange={(isVisible) => setViewPortVisibility(isVisible)} delayedCall>
                    <CountUp
                      redraw={false}
                      end={viewPortEntered ? item.title : 0}
                      start={0}
                      suffix={item.suffix}
                    />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align={'center'} variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align={'center'} component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box maxWidth={700} margin={'0 auto'} position={'relative'}>
        <Box
          component="img"
          height={'100%'}
          width={'100%'}
          src="https://files.tnonetwork.com/shows/cover/pedroconlasmascotas.png"
          alt="Pedro con las Mascotas - TNO Network"
          sx={{ borderRadius: 1.5, boxShadow: 4 }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </Box>
    </Box>
  );
};

export default Metrics;
